import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";

import { Props } from "./interfaces";
import { Actions } from "./styles";
import { DocumentTypeReportExclutionsRilter } from "../../../../models/documents/documents-reports/document-type-report-exclusions-filter";
import { DocumentTypeReportExclusionApiService } from "../../../../services/audit-types/document-type-report-exclusion-api.service";
import { DocumentTypeReportExclutionDTO } from "../../../../models/documents/documents-reports/document-type-report-exclusion-dto ";

const HiddenDocTypes = ({ reportId, legalEntityIds, handleNotifyParent, doUnhideDocType }: Props) => {
  const { t } = useTranslation();

  const [closePopover, setClosePopover] = useState<boolean>(false);
  const [excludedDocTypes, setExcludedDocTypes] = useState<DocumentTypeReportExclutionDTO[] | null>([]);

  const [unhideDocType, setUnhideDocType] = useState<DocumentTypeReportExclutionDTO>();

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    if (reportId) {
      try {
        const response = new DocumentTypeReportExclusionApiService()
          .loadItems(
            { reportId, legalEntityIds } as DocumentTypeReportExclutionsRilter,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            signal
          )
          .then((resp) => {
            const { items, error } = resp;
            if (!signal.aborted) {
              if (!!items && items.length > 0) {
                const docTypes = items;
                setExcludedDocTypes(docTypes);
              } else {
                setExcludedDocTypes([]);
              }
            }
          });

        // const { items, error } = response;

        // if (!signal.aborted) {
        //   if (!!items && items.length > 0) {
        //     const docTypes = items[0].documentTypes;
        //     setExcludedDocTypes(docTypes);
        //   }
        // }
      } catch (error) {
        if (!signal.aborted) {
        }
      }
    }

    return () => abortController.abort();
  }, [reportId, legalEntityIds]);

  // const handleNotify = () => {
  //   // setClosePopover(true);
  //   // close pop-over then notify the parent page
  //   handleNotifyParent();
  //   // setClosePopover(false);
  // };

  const cancel = () => {
    setClosePopover(true);
  };

  const unhideLine = () => {
    if (!!doUnhideDocType) {
      setClosePopover(true);
      if (unhideDocType) {
        doUnhideDocType(unhideDocType);
      }
      handleNotifyParent();
    }
  };

  if (!!excludedDocTypes && excludedDocTypes.length > 0) {
    return (
      <SimplePopover
        buttonType="icon"
        buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        shouldClose={closePopover}
      >
        <Actions>
          <>
            Unhide the following document types
            <List
              sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
              aria-label="contacts"
            >
              {excludedDocTypes?.map((excludedDocType: DocumentTypeReportExclutionDTO, idx) => (
                <ListItem
                  disablePadding
                  key={idx}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <Checkbox
                        value={excludedDocType}
                        checked={unhideDocType?.id === excludedDocType.id}
                        onChange={() => {
                          const toAdd = unhideDocType?.id !== excludedDocType.id;
                          if (toAdd) {
                            setUnhideDocType(excludedDocType);
                          } else {
                            setUnhideDocType(undefined);
                          }
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      inset
                      primary={excludedDocType?.documentType?.name}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            {!!doUnhideDocType && (
              <>
                <Button
                  variant="outlined"
                  onClick={cancel}
                >{`${t("buttons.cancel")}`}</Button>
                <Button
                  disabled={!unhideDocType}
                  onClick={unhideLine}
                >{`${t("buttons.save")}`}</Button>
              </>
            )}
          </>
        </Actions>
      </SimplePopover>
    );
  } else {
    return <></>;
  }
};

export default HiddenDocTypes;
